// This reducer is to hold unchanging "constants" - they might be set dynamically on load but don't change after that
//
// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux
import { get } from 'lodash';

// Action Types
export const typePrefix = 'vra/seasons/';
export const actions = [
  'SET_SEASON'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducers

export default function reducer (
  state={},
  action={}
) {
  switch (action.type) {
    case actions.SET_SEASON:
      return {
        ...state,
        [action.payload.rawSeason.year]: {
          ...get(state, `${action.payload.rawSeason.year}`),
          [action.payload.seasonActivityType]: {
            ...get(state, `${action.payload.rawSeason.year}.${action.payload.seasonActivityType}`),
            [action.payload.cropId]: action.payload.rawSeason
          }
        }
      };
    default:
      return state;
  }
}


// Action Creators

export const setSeason = ({ rawSeason, seasonActivityType, cropId }) => ({
  type: actions.SET_SEASON,
  payload: { seasonActivityType, rawSeason, cropId }
});
